module.exports = __webpack_public_path__ + "static/media/ecommerce.3acf207a.png";